import { PAGES } from "redux/actions/pages/constants";

// feature name
export const SOUND_MATERIAL_ITEMS = `${PAGES} [SoundMaterialItems]`;

// action types
export const SAVE_SOUND_MATERIAL_ITEMS = `${SOUND_MATERIAL_ITEMS} SAVE`;
export const GET_SOUND_MATERIAL_ITEMS = `${SOUND_MATERIAL_ITEMS} GET`;
export const DELETE_SOUND_MATERIAL_ITEM = `${SOUND_MATERIAL_ITEMS} DELETE`;
export const GET_SOUND_MATERIAL_TYPE_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_LOOKUPS`;
export const GET_SOUND_GROUPS_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_SOUND_GROUPS_LOOKUPS`;
export const GET_SOUND_LETTERS_LOOKUPS = `${SOUND_MATERIAL_ITEMS} GET_SOUND_LETTERS_LOOKUPS`;
export const GET_SOUND_MATERIAL_BY_LETTER = `${SOUND_MATERIAL_ITEMS} GET_BY_LETTER`;
export const CREATE_SOUND_MATERIAL = `${SOUND_MATERIAL_ITEMS} CREATE`;
export const GET_ALL_SOUND_MATERIALS = `${SOUND_MATERIAL_ITEMS} GET_ALL_SOUND_MATERIALS`;
export const DELETE_SOUND_MATERIAL = `${SOUND_MATERIAL_ITEMS} DELETE_SOUND_MATERIAL`;

// action creators
export const saveSoundMaterialItems = ({ items }) => ({
  type: SAVE_SOUND_MATERIAL_ITEMS,
  payload: { soundItemArray: items },
});

export const getSoundMaterialItems = () => ({
  type: GET_SOUND_MATERIAL_ITEMS,
});

export const deleteSoundMaterialItem = (soundItemId) => ({
  type: DELETE_SOUND_MATERIAL_ITEM,
  payload: { soundItemId },
});

export const getSoundMaterialTypeLookups = () => ({
  type: GET_SOUND_MATERIAL_TYPE_LOOKUPS,
});

export const getSoundGroupsLookups = () => ({
  type: GET_SOUND_GROUPS_LOOKUPS,
});

export const getSoundLettersLookups = () => ({
  type: GET_SOUND_LETTERS_LOOKUPS,
});

export const getSoundMaterialByLetter = (letter) => ({
  type: GET_SOUND_MATERIAL_BY_LETTER,
  payload: { letter },
});

export const createSoundMaterial = (soundMaterial) => ({
  type: CREATE_SOUND_MATERIAL,
  payload: { soundMaterial },
});

export const getAllSoundMaterials = () => ({
  type: GET_ALL_SOUND_MATERIALS,
});

export const deleteSoundMaterial = (soundMaterialId) => ({
  type: DELETE_SOUND_MATERIAL,
  payload: { soundMaterialId },
});
